// extracted by mini-css-extract-plugin
module.exports = {"root":"NavigationItem-root-lYKSs","anchor":"NavigationItem-anchor-ZGWBb typography-adminTabItem-1fUYn","active":"NavigationItem-active-2qHWV typography-adminTabItemActive-IM5Gj"};